import React from "react";
import { Outlet } from "react-router-dom";

const BrowserLayout = () => {
  return (
    <main className="tc-main-section my-auto" style={{ height: "100vh" }}>
      <div className="tc-container h-100">
        <Outlet />
      </div>
    </main>
  );
};

export default BrowserLayout;
